<template>

    <div class="box box-solid">
        <div class="box-header">
            <h2 class="box-title">{{ lang.get("notes.add.header") }}</h2>
        </div>
        <div class="box-body">
            <div class="form-group">
                <editor
                    v-model="note"
                    :disabled="posting"
                />
            </div>
            <div class="text-right form-group">
                <button class="btn btn-primary btn-sm"
                    @click="onSubmit()"
                    :disabled="!canSubmit"
                >
                  {{ lang.get("notes.add.submit") }}
                </button>
            </div>
        </div>
    </div>

</template>

<script>

import Editor from '../Common/Quill';
import axios from "axios";
import Lang from '../../Lang';

export default {

    components: {
        Editor,
    },

    computed: {

        canSubmit() {
            return this.note !== "" &&
                this.posting === false;
        },

        postData() {
            return {
                note: this.note,
            };
        },

    },

    data() {
        return {
            lang:Lang,
            note:'',
            posting:false,
        }
    },

    methods:{

        onSubmit() {
            if (!this.canSubmit) {
                return;
            }
            this.posting = true;

            axios.post(this.postUrl, this.postData)
                .then(() => {
                    this.$snotify.success('De notitie is opgeslagen');
                    this.resetForm();
                    this.$emit('noteAdded');
                })
                .catch(() => this.$snotify.error("Er is een fout opgetreden bij het opslaan van de notitie"))
                .finally(() => this.posting = false);
        },

        resetForm() {
            this.note = '';
        },

    },

    name:"CrmAddNote",

    props: {
        postUrl: { required:true },
        userName: { required:true },
    },

}

</script>
